import * as Fetch from "../../utils/Fetch"

export interface IUserAuthorizationTableRow {
	id: number,
	name: string,
	kind: string,
	label: string,
	authorizationLevel: string,
	expirationDate: string,
	inceptionDate: string,
	issueId: number,
	relationId: number,
	resourceStatus: string,
	relationStatus: string,
	relationNumber: string,
}

export interface IUserAuthorizationData {
	forDataSetStatus: 'Success' | 'NotPermission' | 'EmployeeNotFound';
	forDataSet: IUserAuthorizationDataRow[],
	forBusinessProcessStatus: 'Success' | 'NotPermission' | 'EmployeeNotFound';
	forBusinessProcess: IUserAuthorizationDataRow[],
}

export interface IUserAuthorizationLoadingData {
	forDataSet: boolean,
	forBusinessProcess: boolean,
}

export interface IUserAuthorizationDataRow extends IUserAuthorizationTableRow {
	period: string,
}

export interface IDictionary<TValue> {
	[id: number]: TValue;
}

interface IRelatedAuthorizationJsonData {
	Kind: string,
	Name: string,
	Label: string,
	Type: string,
	ExpirationDate: string,
	ResourceId: number,
	InceptionDate: string,
	IssueId?: number,
	RelationId: number,
	AuthorizationLevel: string,
	ResourceStatus: string,
	RelationStatus: string,
	RelationNumber: string,
}

interface IGetRelatedDataSetsResourcesResult {
	rows?: IRelatedAuthorizationJsonData[],
	success: boolean;
	status: 'Success' | 'NotPermission' | 'EmployeeNotFound'
}

export default class AuthUserAuthorizationsService {
	getRelatedDataSetsResources(
		issueId: number | string,
		userId: string,
		filterId: string,
		filterExpression: string,
		logFilters: string,
		setRowsPerUsers: (result: IUserAuthorizationDataRow[], status: 'Success' | 'NotPermission' | 'EmployeeNotFound') => void
	) {
		Fetch.get<IGetRelatedDataSetsResourcesResult>("/ResourceRelations/GetRelatedDataSetsResources", {
			issueId: issueId,
			userId: userId,
			filterId: filterId,
			filterExpression: filterExpression,
			filters: logFilters,
		})
			.then(data => {
				if (data.success) {
					var result = data.rows.map((source: IRelatedAuthorizationJsonData) => {
						let target: IUserAuthorizationDataRow = this.mapping(source);

						return target;
					});
					setRowsPerUsers(result, data.status);
					return;
				}
				console.error("Nie udało się pobrać danych.");
				setRowsPerUsers(null, data.status);
			});
	}

	getRelatedBusinessProcessResources(
		issueId: number | string,
		userId: string,
		filterId: string,
		logFilters: string,
		filterExpression: string,
		setRowsPerUsers: (result: IUserAuthorizationDataRow[], status: 'Success' | 'NotPermission' | 'EmployeeNotFound') => void,
	) {
		Fetch.get<any>("/ResourceRelations/GetRelatedBusinessProcessResources", {
			issueId: issueId,
			userId: userId,
			filterId: filterId,
			filters: logFilters,
			filterExpression: filterExpression,
		})
			.then(data => {
				if (data.success) {
					var result = data.rows.map((source: IRelatedAuthorizationJsonData) => {
						let target: IUserAuthorizationDataRow = this.mapping(source);

						return target;
					});
					setRowsPerUsers(result, data.status);
					return;
				}
				console.error("Nie udało się pobrać danych.");
				setRowsPerUsers(null, data.status);
			});
	}

	private mapping(source: IRelatedAuthorizationJsonData): IUserAuthorizationDataRow {
		return {
			authorizationLevel: source.AuthorizationLevel,
			expirationDate: source.ExpirationDate,
			id: source.ResourceId,
			inceptionDate: source.InceptionDate,
			issueId: source.IssueId,
			kind: source.Kind,
			label: source.Label,
			name: source.Name,
			relationId: source.RelationId,
			relationStatus: source.RelationStatus,
			resourceStatus: source.ResourceStatus,
			period: source.InceptionDate,
			relationNumber: source.RelationNumber
		};
	}
}